import { apiGet, apiPost, apiPatch } from '../../../components/qv4/models/shared/apiClient';

const route = query => `/supplier-enquiries-v1/queries/${query}`;
const unwrap = response => {
  const body = response.data;
  if (!body?.success) throw Object.assign(new Error(body?.message || 'Supplier enquiries failed.'), { code: body?.code, data: body?.data });
  return body.data;
};
export const getPlan = query => apiGet(`${route(query)}/plan`).then(unwrap);
export const getSends = query => apiGet(`${route(query)}/sends`).then(unwrap);
export const previewEnquiry = (query, body) => apiPost(`${route(query)}/preview`, body).then(unwrap);
export const sendEnquiry = (query, body, key) => apiPost(`${route(query)}/sends`, body, { headers: { 'Idempotency-Key': key } }).then(response => ({ ...response.data, httpStatus: response.status }));
export const supplierOptions = (search, page = 1) => apiGet(`/suppliers-v1/options?${new URLSearchParams({ search, page, limit: 100 })}`).then(unwrap);
export const getSettings = () => apiGet('/supplier-enquiries-v1/settings').then(unwrap);
export const patchSettings = (enabled, expected) => apiPatch('/supplier-enquiries-v1/settings', { enabled, expected_enabled: expected }).then(unwrap);
export const codeOf = error => error?.response?.data?.code || error?.code;
export const dataOf = error => error?.response?.data?.data || error?.data;
export function messageOf(error) {
  if (error?.response?.status === 403) return "You don't have permission for this.";
  if (codeOf(error) === 'ENQUIRIES_UNAVAILABLE') return 'Supplier enquiries are not available yet.';
  return error?.response?.data?.message || error?.message || 'Supplier enquiries failed.';
}
